const Coupon = {};

Coupon.getVantLanguage = function() {};

/**
 * 计算拼多多/淘宝商品佣金(扣除平台费用，计算可分的佣金)
 * @param {Object} money       原价
 * @param {Object} quan        优惠券
 * @param {Object} commRate    佣金比例
 * @param {Object} plRebatePer 总佣金可分的比例
 */
Coupon.pddCommissionFee = function(money, quan, commRate, plRebatePer) {
  if (commRate) {
    var _quan = 0;
    if (quan) {
      _quan = parseInt(quan);
    }
    var _couponPrice = parseInt(money) - _quan;
    var _commRate = parseInt(commRate);
    var origCommission =
      ((((_couponPrice / 100) * _commRate) / 1000) * plRebatePer) / 100;
    return Math.floor(origCommission * 100) / 100;
  } else {
    return 0;
  }
};

/**
 * 计算 拼多多/淘宝 补贴价(无门槛补贴) (这里只考虑 补贴比例，跟用户的级别没有关系)
 * 主要是 爆品部分
 * @param {Object} money     原价
 * @param {Object} quan      券面额
 * @param {Object} commRate  佣金比例
 * @param {Object} subsidyMax 返利上限（0表示不返利）
 * @param {Object} userInfo 用户信息（里边包含appConfig）
 */
Coupon.pddSubsidyFee = function(money, quan, commRate, subsidyMax, userInfo, appConfig) {
  // 如果补贴最大为0，则返 0;
  if (subsidyMax == 0) {
    return 0;
  }

  if (!userInfo) {
    return 0;
  }
  // plRebatePer 平台返佣百分比比例
  var plRebatePer = appConfig.pddPlRebatePer;
  // dlRebatePer 代理补贴百分比比例（爆品的统一补贴比例，或者代理的返佣比例）
  var dlRebatePer = appConfig.pddDlRebatePer;

  // 商品佣金(扣除平台费用后的)
  var origCommission = this.pddCommissionFee(
    money,
    quan,
    commRate,
    plRebatePer
  );

  if (origCommission < 1) {
    return 0;
  } else if (origCommission > 1 && origCommission <= 2) {
    return 1;
  } else {
    var subsidyMoney = Math.floor((origCommission * dlRebatePer) / 100);
    if (subsidyMoney <= 1) {
      subsidyMoney = 1;
    }
    if (subsidyMoney > parseInt(subsidyMax)) {
      subsidyMoney = parseInt(subsidyMax);
    }
    return subsidyMoney;
  }
};

/**
 * 计算PDD 佣金 （爆品部分，不给佣金。如果已经激活了，相当于计算礼金计算）
 * @param {Object} money
 * @param {Object} quan
 * @param {Object} commRate
 * @param {Object} subsidyMax 补贴最大(0表示没有补贴)
 * @param {Object} userInfo(用户信息，里边包含appconfig)
 * @param {Object} rebateFlag(是否返利)
 */
Coupon.pddRebateFee = function(
  money,
  quan,
  commRate,
  subsidyMax,
  userInfo,
  appConfig,
  rebateFlag
) {
  if (rebateFlag == '0') {
    return 0;
  }
  if (!userInfo ) {
    return 0;
  }

  var userType = userInfo.userType;
  var shareLevel = userInfo.shareLevel;

  // 计算补贴
  var subsidyMoney = this.pddSubsidyFee(
    money,
    quan,
    commRate,
    subsidyMax,
    userInfo,
    appConfig
  );
  // plRebatePer 平台返佣百分比比例
  var plRebatePer = appConfig.pddPlRebatePer;
  // dlRebatePer 代理补贴百分比比例（爆品的统一补贴比例，或者代理的返佣比例）
  var dlRebatePer = appConfig.pddDlRebatePer;

  // 商品佣金(扣除平台费用后的)
  var origCommission = this.pddCommissionFee(
    money,
    quan,
    commRate,
    plRebatePer
  );

  if (origCommission <= 0 || origCommission <= subsidyMoney) {
    return 0;
  }
  var restCommission = origCommission - subsidyMoney;
  var rebate = 0;

  // 团长佣金比例
  var subsidyPer = userInfo.subsidyPer;
  // VIP代理佣金比例
  var serviceRate = userInfo.serviceRate;
  // A级代理佣金比例
  var yeyeRate = appConfig.yeyeAgentRate;
  // B级代理佣金比例
  var babaRate = appConfig.babaAgentRate;
  // C级代理佣金比例
  var agentRate = appConfig.agentRate;

  if (serviceRate == 100) {
    rebate = restCommission;
  } else {
    if (userType < 3) {
      if (shareLevel == 2) {
        rebate =
          (restCommission * 0.8 * (1 - subsidyPer / 100) * agentRate) / 100;
      } else if (shareLevel == 1) {
        rebate =
          (restCommission *
            0.8 *
            (1 - subsidyPer / 100) *
            (agentRate + babaRate)) /
          100;
      } else {
        rebate = restCommission * 0.8 * (1 - subsidyPer / 100);
      }
    } else {
      rebate =
        (restCommission * 0.8 * (1 - subsidyPer / 100) * agentRate) / 100;
    }
  }
  return Math.floor(rebate * 100) / 100;
};

/**
 * 计算 拼多多券后/补贴价
 * @param {Object} money
 * @param {Object} quan
 * @param {Object} commRate
 * @param {Object} subsidyMax 补贴最大(0表示没有补贴)
 * @param {Object} userInfo 用户信息（里边包含appConfig）
 * @param {Object} rebateFlag 是否返佣(0:不返;1:返利)
 */
Coupon.pddCouponPrice = function(
  money,
  quan,
  commRate,
  subsidyMax,
  userInfo,
  appConfig,
  rebateFlag
) {
  // 补贴费
  var subsidyMoney = this.pddSubsidyFee(
    money,
    quan,
    commRate,
    subsidyMax,
    userInfo,
    appConfig
  );
  // 返利费
  var rebateFee = 0; //pddRebateFee(money, quan, commRate, subsidyMax, userInfo, rebateFlag);
  // 优惠券
  var _quan = 0;
  if (quan) {
    _quan = parseInt(quan);
  }
  var couponPrice = (parseInt(money) - _quan) / 100 - subsidyMoney - rebateFee;
  return Math.round(couponPrice * 100) / 100;
};

/**
 * 计算京东商品佣金(扣除平台费用后，计算可分的佣金)
 * @param {Object} afterQuanPrice 券后价
 * @param {Object} commRate 佣金比例
 * @param {Object} plRebatePer 总佣金可分的比例
 */
Coupon.jdCommissionFee = function(afterQuanPrice, commRate, plRebatePer) {
  if (commRate) {
    var origCommission =
      (((afterQuanPrice * commRate) / 100) * plRebatePer) / 100;
    return Math.floor(origCommission * 100) / 100;
  } else {
    return 0;
  }
};

/**
 * 计算 京东 补贴价(无门槛补贴) (这里只考虑 补贴比例，跟用户的级别没有关系)
 * 主要是 爆品部分
 * @param {Object} afterQuanPrice  原价
 * @param {Object} commRate  佣金比例
 * @param {Object} subsidyMax 返利上限（0表示不返利）
 * @param {Object} userInfo 用户信息（里边包含appConfig）
 */
Coupon.jdSubsidyFee = function(afterQuanPrice, commRate, subsidyMax, userInfo, appConfig) {
  // 如果补贴最大为0，则返 0;
  if (subsidyMax == 0) {
    return 0;
  }

  if (!userInfo) {
    return 0;
  }
  // plRebatePer 平台返佣百分比比例
  var plRebatePer = appConfig.jdPlRebatePer;
  // dlRebatePer 代理补贴百分比比例（爆品的统一补贴比例，或者代理的返佣比例）
  var dlRebatePer = appConfig.jdDlRebatePer;

  // 商品佣金(扣除平台费用后的)
  var origCommission = this.jdCommissionFee(
    afterQuanPrice,
    commRate,
    plRebatePer
  );

  if (origCommission < 1) {
    return 0;
  } else if (origCommission > 1 && origCommission <= 2) {
    return 1;
  } else {
    var subsidyMoney = Math.floor((origCommission * dlRebatePer) / 100);
    if (subsidyMoney <= 1) {
      subsidyMoney = 1;
    }
    if (subsidyMoney > parseInt(subsidyMax)) {
      subsidyMoney = parseInt(subsidyMax);
    }
    return subsidyMoney;
  }
};

/**
 * 计算 JD 佣金 （爆品部分，不给佣金。如果已经激活了，相当于计算礼金计算）
 * @param {Object} afterQuanPrice
 * @param {Object} commRate
 * @param {Object} subsidyMax 补贴最大(0表示没有补贴)
 * @param {Object} userInfo(用户信息，里边包含appconfig)
 * @param {Object} rebateFlag(是否返利)
 */
Coupon.jdRebateFee = function(
  afterQuanPrice,
  commRate,
  subsidyMax,
  userInfo,
  appConfig,
  rebateFlag
) {
  if (rebateFlag == '0') {
    return 0;
  }
  if (!userInfo) {
    return 0;
  }

  var userType = userInfo.userType;
  var shareLevel = userInfo.shareLevel;

  // 计算补贴
  var subsidyMoney = this.jdSubsidyFee(
    afterQuanPrice,
    commRate,
    subsidyMax,
    userInfo,
    appConfig
  );
  // plRebatePer 平台返佣百分比比例
  var plRebatePer = appConfig.jdPlRebatePer;
  // dlRebatePer 代理补贴百分比比例（爆品的统一补贴比例，或者代理的返佣比例）
  var dlRebatePer = appConfig.jdDlRebatePer;

  // 商品佣金(扣除平台费用后的)
  var origCommission = this.jdCommissionFee(
    afterQuanPrice,
    commRate,
    plRebatePer
  );

  if (origCommission <= 0 || origCommission <= subsidyMoney) {
    return 0;
  }
  var restCommission = origCommission - subsidyMoney;
  var rebate = 0;

  // 团长佣金比例
  var subsidyPer = userInfo.subsidyPer;
  // VIP代理佣金比例
  var serviceRate = userInfo.serviceRate;
  // A级代理佣金比例
  var yeyeRate = appConfig.yeyeAgentRate;
  // B级代理佣金比例
  var babaRate = appConfig.babaAgentRate;
  // C级代理佣金比例
  var agentRate = appConfig.agentRate;

  if (serviceRate == 100) {
    rebate = restCommission;
  } else {
    if (userType < 3) {
      if (shareLevel == 2) {
        rebate =
          (restCommission * 0.8 * (1 - subsidyPer / 100) * agentRate) / 100;
      } else if (shareLevel == 1) {
        rebate =
          (restCommission *
            0.8 *
            (1 - subsidyPer / 100) *
            (agentRate + babaRate)) /
          100;
      } else {
        rebate = restCommission * 0.8 * (1 - subsidyPer / 100);
      }
    } else {
      rebate =
        (restCommission * 0.8 * (1 - subsidyPer / 100) * agentRate) / 100;
    }
  }
  return Math.floor(rebate * 100) / 100;
};

/**
 * 计算 京东券后/补贴价
 * @param {Object} money
 * @param {Object} quan
 * @param {Object} commRate
 * @param {Object} subsidyMax 补贴最大(0表示没有补贴)
 * @param {Object} userInfo 用户信息（里边包含appConfig）
 * @param {Object} rebateFlag 是否返佣(0:不返;1:返利)
 */
Coupon.jdCouponPrice = function(
  afterQuanPrice,
  commRate,
  subsidyMax,
  userInfo,
  appConfig,
  rebateFlag
) {
  // 补贴费
  var subsidyMoney = this.jdSubsidyFee(
    afterQuanPrice,
    commRate,
    subsidyMax,
    userInfo,
    appConfig
  );

  // 返利费
  var rebateFee = 0; //jdRebateFee(afterQuanPrice, commRate, subsidyMax, userInfo, rebateFlag);

  return Math.round((afterQuanPrice - subsidyMoney - rebateFee) * 100) / 100;
};

/**
 * 计算淘宝商品佣金(扣除平台费用，计算可分的佣金)
 * @param {Object} money       原价
 * @param {Object} quan        优惠券
 * @param {Object} commRate    佣金比例
 * @param {Object} plRebatePer 总佣金可分的比例
 */
Coupon.tbCommissionFee = function(money, quan, commRate, plRebatePer) {
  if (commRate) {
    var _quan = 0;
    if (quan) {
      _quan = parseInt(quan);
    }
    var _couponPrice = parseFloat(money) - _quan;
    var _commRate = parseFloat(commRate);
    var origCommission =
      (((_couponPrice * _commRate) / 100) * plRebatePer) / 100;
    return Math.floor(origCommission * 100) / 100;
  } else {
    return 0;
  }
};

/**
 * 计算 淘宝 补贴价(无门槛补贴) (这里只考虑 补贴比例，跟用户的级别没有关系)
 * 主要是 爆品部分
 * @param {Object} money     原价
 * @param {Object} quan      券面额
 * @param {Object} commRate  佣金比例
 * @param {Object} subsidyMax 返利上限（0表示不返利）
 * @param {Object} userInfo 用户信息（里边包含appConfig）
 */
Coupon.tbSubsidyFee = function(money, quan, commRate, subsidyMax, userInfo, appConfig) {
  // 如果补贴最大为0，则返 0;
  if (subsidyMax == 0) {
    return 0;
  }

  if (!userInfo) {
    return 0;
  }
  // plRebatePer 平台返佣百分比比例
  var plRebatePer = appConfig.tbPlRebatePer;
  // dlRebatePer 代理补贴百分比比例（爆品的统一补贴比例，或者代理的返佣比例）
  var dlRebatePer = appConfig.tbDlRebatePer;

  // 商品佣金(扣除平台费用后的)
  var origCommission = this.tbCommissionFee(money, quan, commRate, plRebatePer);

  if (origCommission < 1) {
    return 0;
  } else if (origCommission > 1 && origCommission <= 2) {
    return 1;
  } else {
    var subsidyMoney = Math.floor((origCommission * dlRebatePer) / 100);
    if (subsidyMoney <= 1) {
      subsidyMoney = 1;
    }
    if (subsidyMoney > parseInt(subsidyMax)) {
      subsidyMoney = parseInt(subsidyMax);
    }
    return subsidyMoney;
  }
};

/**
 * 计算淘宝 佣金 （爆品部分，不给佣金。如果已经激活了，相当于计算礼金计算）
 * @param {Object} money
 * @param {Object} quan
 * @param {Object} commRate
 * @param {Object} subsidyMax 补贴最大(0表示没有补贴)
 * @param {Object} userInfo(用户信息，里边包含appconfig)
 * @param {Object} rebateFlag(是否返利)
 */
Coupon.tbRebateFee = function(
  money,
  quan,
  commRate,
  subsidyMax,
  userInfo,
  appConfig,
  rebateFlag
) {
  if (rebateFlag == '0') {
    return 0;
  }
  if (!userInfo) {
    return 0;
  }

  var userType = userInfo.userType;
  var shareLevel = userInfo.shareLevel;

  // 计算补贴
  var subsidyMoney = this.tbSubsidyFee(
    money,
    quan,
    commRate,
    subsidyMax,
    userInfo,
    appConfig
  );
  // plRebatePer 平台返佣百分比比例
  var plRebatePer = appConfig.tbPlRebatePer;
  // dlRebatePer 代理补贴百分比比例（爆品的统一补贴比例，或者代理的返佣比例）
  var dlRebatePer = appConfig.tbDlRebatePer;

  // 商品佣金(扣除平台费用后的)
  var origCommission = this.tbCommissionFee(money, quan, commRate, plRebatePer);

  if (origCommission <= 0 || origCommission <= subsidyMoney) {
    return 0;
  }
  var restCommission = origCommission - subsidyMoney;
  var rebate = 0;

  // 团长佣金比例
  var subsidyPer = userInfo.subsidyPer;
  // VIP代理佣金比例
  var serviceRate = userInfo.serviceRate;
  // A级代理佣金比例
  var yeyeRate = appConfig.yeyeAgentRate;
  // B级代理佣金比例
  var babaRate = appConfig.babaAgentRate;
  // C级代理佣金比例
  var agentRate = appConfig.agentRate;

  if (serviceRate == 100) {
    rebate = restCommission;
  } else {
    if (userType < 3) {
      if (shareLevel == 2) {
        rebate =
          (restCommission * 0.8 * (1 - subsidyPer / 100) * agentRate) / 100;
      } else if (shareLevel == 1) {
        rebate =
          (restCommission *
            0.8 *
            (1 - subsidyPer / 100) *
            (agentRate + babaRate)) /
          100;
      } else {
        rebate = restCommission * 0.8 * (1 - subsidyPer / 100);
      }
    } else {
      rebate =
        (restCommission * 0.8 * (1 - subsidyPer / 100) * agentRate) / 100;
    }
  }
  return Math.floor(rebate * 100) / 100;
};

/**
 * 计算 淘宝券后/补贴价
 * @param {Object} money
 * @param {Object} quan
 * @param {Object} commRate
 * @param {Object} subsidyMax 补贴最大(0表示没有补贴)
 * @param {Object} userInfo 用户信息（里边包含appConfig）
 * @param {Object} rebateFlag 是否返佣(0:不返;1:返利)
 */
Coupon.tbCouponPrice = function(
  money,
  quan,
  commRate,
  subsidyMax,
  userInfo,
  appConfig,
  rebateFlag
) {
  // 补贴费
  var subsidyMoney = this.tbSubsidyFee(
    money,
    quan,
    commRate,
    subsidyMax,
    userInfo,
    appConfig
  );
  // 返利费
  var rebateFee = 0; //pddRebateFee(money, quan, commRate, subsidyMax, userInfo, rebateFlag);
  // 优惠券
  var _quan = 0;
  if (quan) {
    _quan = parseInt(quan);
  }
  var couponPrice = parseFloat(money) - _quan - subsidyMoney - rebateFee;
  return Math.round(couponPrice * 100) / 100;
};

export default Coupon;
